import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { cardSizeVariant } from './card-variants'

type Props = ComponentPropsWithoutRef<'div'> & {
  /** カードのサイズ */
  size?: 'default' | 'small'
}

export const Card: FC<Props> = ({
  children,
  size = 'default',
  className,
  ...props
}) => {
  return (
    <div {...props} className={clsx([cardSizeVariant({ size }), className])}>
      {children}
    </div>
  )
}
